import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

type TpConfig = {
  isProd: boolean;
};

let config: TpConfig | undefined;

dayjs.extend(utc);

export function setConfig(cfg: TpConfig): void {
  config = cfg;
}

export function getConfig(): TpConfig {
  if (!config) {
    throw new Error(
      'config is not set, please call `setConfig()` at the start of your application',
    );
  }
  return config;
}
